var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 568.042,
    height: 545.172,
    viewBox: "0 0 568.042 545.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16610",
    "data-name": "Rectangle 16610",
    width: 568.042,
    height: 545.172,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.198,
    y1: 0.312,
    x2: 0.084,
    y2: 0.813,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f27705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcc98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.721,
    y1: 0,
    x2: 0.022,
    y2: 0.195,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.692,
    y1: 0.701,
    x2: 0.628,
    y2: 0.069,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.016,
    y1: 0.988,
    x2: 0.299,
    y2: 0.368,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58483",
    "data-name": "Group 58483",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75607",
    "data-name": "Path 75607",
    d: "M126.007,1.3s27.929,64.667,81.21,61.23c69.169-4.463,141.8-69.609,268.767-47.695,0,0-157.05-18.906-347.4,199.8C128.585,214.639,91.2,88.313,126.007,1.3Z",
    transform: "translate(-3.437 -0.04)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75608",
    "data-name": "Path 75608",
    d: "M480.868,15.39S428.462,62.812,447.587,111.5c23.389,59.538,109.85,113.509,128.055,241.065,0,0-34.87-156.307-295.972-268.337C279.67,84.224,387.371,9.037,480.868,15.39Z",
    transform: "translate(-8.645 -0.464)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75609",
    "data-name": "Path 75609",
    d: "M575.988,358.381s-60.25-36.494-101.668-2.8C420.552,399.32,399.151,494.508,283,550.272c0,0,137.579-73.522,165.857-362.082C448.853,188.19,549.829,265.963,575.988,358.381Z",
    transform: "translate(-8.747 -5.817)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75610",
    "data-name": "Path 75610",
    d: "M274.45,554.615s15.2-69.023-28.608-97.6C192.266,422.068,89.237,431.537.447,338.166c0,0,113.759,108.6,398.019,43.71C398.466,381.876,354.311,505.58,274.45,554.615Z",
    transform: "translate(-0.014 -10.453)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75611",
    "data-name": "Path 75611",
    d: "M1.278,328.115s70.176-5.5,83.52-56.073c16.319-61.85-23.309-155.8,37.39-269.458,0,0-68.1,139.6,82.92,389.018C205.109,391.6,78.137,391.117,1.278,328.115Z",
    transform: "translate(-0.04 -0.08)",
    fill: "url(#linear-gradient-5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape01);
export default __webpack_public_path__ + "static/media/shape_01.2bcc50889ab8d3141b7ca964735f66fb.svg";
export { ForwardRef as ReactComponent };